import { useEffect, useState } from "react";
import { get, patchRequest } from "../../../http/api";
import { FaStop, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";



export default function HighlightsSection() {
  const [highlights, setHighlights] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    fetchHighlights();
  }, []);

  const fetchHighlights = async () => {
    try {
      const res = await get("profile/highlights");
      setHighlights(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAdd = () => {
    if (!input.trim()) return;
    if (highlights.length >= 5) return;
    if (input.length > 40) return;

    setHighlights([...highlights, input.trim()]);
    setInput("");
    setSuccess(false);
  };

  const handleRemove = (index) => {
    const updated = highlights.filter((_, i) => i !== index);
    setHighlights(updated);
    setSuccess(false);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await patchRequest("profile/highlights", { highlights });
      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="settings-card">
      <h3>{t("highlights.title")}</h3>
      <p className="settings-hint">
        {t("highlights.description")}
      </p>

      <div className="highlight-input">
        <input
          value={input}
          maxLength={40}
          placeholder={t("highlights.placeholders.example")}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
        />
        <button
          className="highlight-add-btn"
          onClick={handleAdd}
          disabled={highlights.length >= 5}
        >
          +
        </button>
      </div>

      <div className="highlights-list">
        {highlights.map((item, index) => (
          <div key={index} className="highlight-chip">
            <span>{item}</span>
            <FaTimes onClick={() => handleRemove(index)} />
          </div>
        ))}
      </div>

      {highlights.length >= 5 && (
        <p className="highlight-limit-msg">
          <>
            <FaStop />
            {" "}
            {t("highlights.limit.reached")}
          </>
        </p>
      )}

      <small>
        {
          t(
            "highlights.limit.used",
            {
              count: highlights.length
            }
          )
        }
      </small>

      <div className="settings-actions">
        <button
          className="btn primary"
          onClick={handleSave}
          disabled={loading}
        >
          {
            loading
              ? t("highlights.buttons.saving")
              : t("highlights.buttons.save")
          }
        </button>

        {success && <span className="success-msg">{t("highlights.success.saved")}</span>}
      </div>
    </section>
  );
}